module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Issam Ghazzawi is a distinguished professor of management at the University of La Verne. He received his Ph.D. from the University of Pittsburgh, his Master’s in Labor and Human Resources (M.L.H.R.) from Ohio State University, and his Master’s in Business Administration (MBA) from Sul Ross State University. Additionally, he has more than 20 years of executive management experience and served on several organizations’ advisory boards.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Over the years, he received numerous national and international academic awards. He has also received numerous communities, State of California Assembly, State of California Senate, United States Congress, and the United States Senate awards and recognitions for his service to the community. He serves on the editorial review boards of several academic journals. He started publishing children’s stories in a foreign language at the age of 17.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0